// extracted by mini-css-extract-plugin
export default {"option":"dropdown_option__WYSFz","selected":"dropdown_selected__R2A7x"};